import {
	Box,
	Button,
	Flex,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
	Table,
	TableContainer,
	Tbody,
	Td,
	Th,
	Thead,
	Tr,
} from '@chakra-ui/react';
import { Form, Formik } from 'formik';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import DateInputFormField from '../form/DateInputFormField';
import PreUploadFileFormField from '../form/PreUploadFileFormField';
import RadioFormField from '../form/RadioFormField';
import TextAreaFormField from '../form/TextAreaFormField';
import TextFormField from '../form/TextFormField';

import { faPenSquare, faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';
import moment from 'moment';
import { v4 as uuid } from 'uuid';
import c from '../../constant';
import useStore from '../../store';
import DownloadAndViewButtonUserUpload from '../Files/DownloadAndViewButtonUserUpload';
import DropDownField from '../form/DropDownField';

const TableFormField = (props) => {
	const { t } = useTranslation('common');
	const { currentLang } = useStore((state) => state.currentLang);
	moment.locale(currentLang === 'kh' ? 'km' : 'en-gb');
	const { name, label, labelKh, columns, value, orderBy, onSave } = props;
	const [editRow, setEditRow] = useState(null);
	const [openEditRow, setOpenEditRow] = useState(false);
	const [isEditing, setIsEditing] = useState(false);
	const sanitizeRows = (rows) => (Array.isArray(rows) ? rows.filter((row) => row && typeof row === 'object') : []);
	const originalValue = sanitizeRows(value);
	const [tableData, setTableData] = useState(() => sanitizeRows(value));

	function onAdd(e) {
		let tmpData = [...tableData];
		tmpData = [...tmpData, e];
		setTableData(tmpData);
	}

	function onUpdate(e) {
		let tmpData = [...tableData];
		let updateTmpData = [];
		tmpData.map((item) => {
			if (item?.id === e?.id) {
				updateTmpData.push(e);
			} else {
				updateTmpData.push(item);
			}
		});
		setTableData(updateTmpData);
	}

	function onDelete(e) {
		let tmpData = [...tableData];
		let updateTmpData = [];
		tmpData.map((item) => {
			if (item?.id === e?.id) {
			} else {
				updateTmpData.push(item);
			}
		});
		setTableData(updateTmpData);
		setOpenEditRow(false);
	}

	function displayRowData({ value, type, options }) {
		switch (type) {
			case 'text':
				return value;
			case 'capitalText':
				return value?.toUpperCase();
			case 'textArea':
				return <pre style={{ maxWidth: 400, whiteSpace: 'pre-wrap' }}>{value}</pre>;
			case 'date':
				return value ? moment(value).format(c.excelDateOnlyTextFormat) : '';
			case 'file': {
				let tmpValue = null;

				try {
					if (!value) {
						tmpValue = null;
					} else if (typeof value === 'string') {
						tmpValue = JSON.parse(value);
					} else {
						tmpValue = value;
					}
				} catch (error) {
					console.error('Invalid file value:', value);
					tmpValue = null;
				}

				return tmpValue ? <DownloadAndViewButtonUserUpload url={tmpValue?.file} size={tmpValue?.fileSize || tmpValue?.size} /> : '';
			}
			case 'radio': {
				return t(value);
			}
			case 'dropdown': {
				const selectedOption = options?.find((item) => item.value.toString() === value?.toString());
				return selectedOption?.label || '';
			}
			default:
				return '';
		}
	}

	return (
		<Flex direction="column" border={`3px dashed ${isEditing ? '#e74c3c' : 'white'}`}>
			<Flex mt="4" mb="4" alignItems="center">
				{currentLang === 'kh' ? labelKh : label}
				{isEditing && (
					<Button
						variant="outline"
						size="sm"
						ml="4"
						borderRadius={'0px !important'}
						onClick={() => {
							setTableData(originalValue);
							setIsEditing(false);
						}}
						colorScheme="gray"
					>
						{t(`Cancel`)}
					</Button>
				)}
				{isEditing && (
					<Button
						id="login-btn"
						// variant="outline"
						size="sm"
						ml="4"
						borderRadius={'0px !important'}
						leftIcon={<FontAwesomeIcon icon={faSave} style={{ fontSize: 14 }} />}
						colorScheme="green"
						// type="submit"
						onClick={() => onSave(sanitizeRows(tableData))}
						// isLoading={loading}
						loadingText={t('Save')}
						spinnerPlacement="start"
					>
						{t(`Save`)}
					</Button>
				)}
				{!isEditing && (
					<Button
						variant="outline"
						size="sm"
						ml="4"
						borderRadius={'0px !important'}
						leftIcon={<FontAwesomeIcon icon={faPenSquare} style={{ fontSize: 14 }} />}
						onClick={() => setIsEditing(true)}
						colorScheme="whatsapp"
					>
						{t(`Edit`)}
					</Button>
				)}
			</Flex>
			<TableContainer p="26px" pt="0">
				<Table variant="simple">
					<Thead>
						<Tr>
							{columns?.map((item, index) => {
								if (!item?.hide) {
									return <Th key={`th-${index}`}>{currentLang === 'kh' ? item?.labelKh : item?.label}</Th>;
								}
							})}
						</Tr>
					</Thead>
					<Tbody>
						{(!tableData || sanitizeRows(tableData)?.length <= 0) && (
							<Tr>
								{columns?.map((item, index) => {
									if (!item?.hide) {
										return <Td key={`td-null-${index}`}>N/A</Td>;
									}
								})}
							</Tr>
						)}
						{_.orderBy(sanitizeRows(tableData), [`${orderBy?.field}`], [`${orderBy?.type}`])?.map((item, index) => {
							return (
								<Tr
									key={`td-${index}`}
									onClick={() => {
										if (isEditing && !item?.trainingRecordId) {
											setOpenEditRow(true);
											setEditRow(item);
										}
									}}
									bg={isEditing && item?.trainingRecordId ? 'gray.100' : 'transparent'}
									opacity={isEditing && item?.trainingRecordId ? '0.60' : '1'}
									cursor={isEditing ? (item?.trainingRecordId ? 'not-allowed' : 'pointer') : 'unset'}
									_hover={{
										bg: isEditing && item?.trainingRecordId ? 'gray.100' : 'rgba(236, 240, 241,.3)',
									}}
								>
									{columns?.map((col, colIndex) => {
										if (!col?.hide) {
											return (
												<Td key={`td-${index}-${colIndex}`}>
													{displayRowData({ value: item[col?.name], type: col?.type, options: col?.options })}
												</Td>
											);
										}
									})}
								</Tr>
							);
						})}
					</Tbody>
				</Table>
			</TableContainer>
			{isEditing && <RowForm {...props} onAdd={onAdd} type="add" />}

			{isEditing && openEditRow && (
				<RowForm
					{...props}
					onUpdate={onUpdate}
					initData={editRow}
					type="edit"
					onCloseCallBack={() => {
						setOpenEditRow(false);
						setEditRow(null);
					}}
					onDelete={onDelete}
				/>
			)}
		</Flex>
	);
};

export default TableFormField;

const RowForm = (props) => {
	const { t } = useTranslation('common');
	const { name, label, columns, value, onAdd, type, onCloseCallBack = () => null, initData, onUpdate, onDelete } = props;
	const [schem, setSchem] = useState(null);
	const [initValue, setInitValue] = useState(null);
	const [isOpen, setIsOpen] = useState(type === 'add' ? false : true);
	const { currentLang } = useStore((state) => state.currentLang);
	const isFromTrainingRecord = !!initData?.trainingRecordId;
	const [uuidRow, setUuidRow] = useState(uuid());

	useEffect(() => {
		if (columns) {
			let tmpSchem = {};
			let tmpInitValue = {};
			columns?.map((item, index) => {
				if (item?.type === 'text' || item?.type === 'capitalText') {
					tmpSchem = { ...tmpSchem, [item?.name]: Yup.string() };
					tmpInitValue = { ...tmpInitValue, [item?.name]: initData ? initData[item?.name] : item?.name === 'id' ? uuidRow : '' };
				} else if (item?.type === 'file') {
					tmpSchem = { ...tmpSchem, [item?.name]: Yup.string() };
					tmpInitValue = { ...tmpInitValue, [item?.name]: initData ? initData[item?.name] : item?.name === 'id' ? uuidRow : '' };
				} else if (item?.type === 'textArea') {
					tmpSchem = { ...tmpSchem, [item?.name]: Yup.string() };
					tmpInitValue = { ...tmpInitValue, [item?.name]: initData ? initData[item?.name] : '' };
				} else if (item?.type === 'date') {
					tmpSchem = { ...tmpSchem, [item?.name]: Yup.string().nullable() };
					tmpInitValue = { ...tmpInitValue, [item?.name]: initData ? initData[item?.name] : '' };
				} else if (item?.type === 'radio') {
					tmpSchem = { ...tmpSchem, [item?.name]: Yup.string() };
					tmpInitValue = { ...tmpInitValue, [item?.name]: initData ? initData[item?.name] : '' };
				} else if (item?.type === 'dropdown') {
					tmpSchem = { ...tmpSchem, [item?.name]: Yup.string() };
					tmpInitValue = { ...tmpInitValue, [item?.name]: initData ? initData[item?.name] : item?.name === 'id' ? uuidRow : '' };
				} else {
					tmpSchem = { ...tmpSchem, [item?.name]: Yup.string() };
					tmpInitValue = { ...tmpInitValue, [item?.name]: initData ? initData[item?.name] : '' };
				}
			});
			setSchem(
				Yup.object().shape({
					...tmpSchem,
				}),
			);
			setInitValue(tmpInitValue);
		}
	}, [columns, uuidRow]);

	return (
		<>
			{type === 'add' && (
				<Button mb="26px" ml="26px" mr="26px" colorScheme="green" borderRadius="0px !important" onClick={() => setIsOpen(true)}>
					{t('Add')}
				</Button>
			)}
			<Modal
				isOpen={isOpen}
				onClose={() => {
					setIsOpen(false);
					onCloseCallBack();
				}}
			>
				<ModalOverlay />
				<ModalContent>
					<ModalHeader>{t('Add')}</ModalHeader>
					<ModalCloseButton />
					<ModalBody mb="4">
						{schem && initValue && (
							<Formik
								key="inputFormTable"
								initialValues={{ ...initValue }}
								validationSchema={schem}
								onSubmit={(values) => {
									if (type === 'add') {
										setUuidRow(uuid());
										onAdd(values);
										setIsOpen(false);
									} else {
										onUpdate(values);
										onCloseCallBack();
									}
								}}
							>
								{(props) => {
									return (
										<Box>
											<Form key="formKey">
												{columns.map((col, colIndex) => {
													return (
														<Box key={`td-add-${colIndex}`} display={col?.hide ? 'none' : 'unset'}>
															{(col.type === 'text' || col.type === 'capitalText') && (
																<TextFormField
																	{...props}
																	label={currentLang === 'kh' ? col?.labelKh : col?.label}
																	name={col?.name}
																	disabled={isFromTrainingRecord}
																/>
															)}
															{col.type === 'file' && (
																<PreUploadFileFormField
																	{...props}
																	label={currentLang === 'kh' ? col?.labelKh : col?.label}
																	name={col?.name}
																	disabled={isFromTrainingRecord}
																/>
															)}
															{col.type === 'textArea' && (
																<TextAreaFormField
																	{...props}
																	label={currentLang === 'kh' ? col?.labelKh : col?.label}
																	name={col?.name}
																	disabled={isFromTrainingRecord}
																/>
															)}
															{col.type === 'date' && (
																<DateInputFormField
																	{...props}
																	label={currentLang === 'kh' ? col?.labelKh : col?.label}
																	name={col?.name}
																	initialDate={initValue[col?.name] || null}
																	disabled={isFromTrainingRecord}
																/>
															)}

															{col.type === 'radio' && (
																<RadioFormField
																	{...props}
																	label={col?.label}
																	name={col?.name}
																	radios={col?.options}
																	initValue={initValue[col?.name] || ''}
																	disabled={isFromTrainingRecord}
																/>
															)}
															{col.type === 'dropdown' && (
																<DropDownField
																	{...props}
																	label={currentLang === 'kh' ? col?.labelKh : col?.label}
																	name={col?.name}
																	placeholder={t('Please select an option')}
																	options={col?.options}
																	initValue={initValue[col?.name] || ''}
																/>
															)}
														</Box>
													);
												})}
												<Flex justifyContent="flex-end">
													{type === 'edit' && !isFromTrainingRecord && (
														<Button
															variant="ghost"
															colorScheme="red"
															size="md"
															h="42px"
															w="128px"
															mr="4"
															onClick={() => onDelete(initData)}
														>
															{t(`Delete`)}
														</Button>
													)}
													<Button
														id="login-btn"
														variant="solid"
														size="md"
														h="42px"
														w="128px"
														bg="primary.dark"
														_hover={{ bg: 'primary.dark' }}
														color="white"
														type="submit"
														loadingText={t('CREATE')}
														spinnerPlacement="start"
													>
														{t(type === 'add' ? `Add` : `Update`)}
													</Button>
												</Flex>
											</Form>
										</Box>
									);
								}}
							</Formik>
						)}
					</ModalBody>
				</ModalContent>
			</Modal>
		</>
	);
};
